<template>
    <div class="relative geography"
         :class="{'pt-8': withStep}">
        <span class="label-step top-0 left-[-1rem]" v-if="withStep">2</span>

        <h2 class="text-[16px]" ref="geography" >
            <span v-if="$widgetUI=='OLD-UI'">Geography <span class="font-light text-[12px] text-gray-400">(Select One or More)</span></span>
        </h2>

        <div>
            <v-radio v-model="geography"
                     value="all">
                Whole USA
            </v-radio>
        </div>

        <div v-for="item in listing">
            <div class="relative">
                <v-radio v-model="geography"
                         :value="item.type">
                    <span>{{ item.title }}</span>
                </v-radio>
                <help-tip v-if="item.type === 'multi-location-radius'"
                          content="After entering radius (in miles), and zip code, select 'ADD' to complete."/>
            </div>
            <template v-if="item.type === 'geo_search'">
                <div v-show="geography === 'geo_search'">
                    <search-state :code="codeGeo"
                                  :select-code="item.code"
                                  :text="'Examples: \'60093\', \'Dallas\', \'CA\''"
                                  @selected="selectedState"/>
                </div>
            </template>
            <template v-if="item.type === 'multi-location-radius'">
                <div v-show="geography === 'multi-location-radius'">
                    <search-zip :code="codeGeo"
                                :select-code="item.code"
                                @selected="selectedZip"
                                @change-radius="changeRadius"/>
                </div>
            </template>
            <template v-if="item.type === 'mapping'">
                <div v-show="geography === 'mapping'">
                    <search-map :code="codeGeo"
                                :text="'Create a custom map by clicking points around your desired area to create a closed shape.'"
                                @selected="selectedMap"/>
                </div>
            </template>
        </div>


        <div v-if="geography !== 'all' || $widgetUI=='OLD-UI' " class="vue-map-container mt-4 "  style="width: 100%; height: 400px;">
            <google-map
                class="mt-4"
                :type="geography"
                :markerProp="marker"
                :zoom="zoom"
                :radius="radius"
                :markerType="markerType"
                @set-polygon="setPolygon"
            />
            <div class="bg-text">
                <button class="btn" @click="showMapModal">View in full screen</button>
            </div>
        </div>
        <modal name="modal-map"
               :adaptive="true"
               :scrollable="true"
               :clickToClose="true"
               :resizable="true"
               classes="map-modal rounded-lg">
            <template>
                <icon-close class="absolute right-2 top-2 z-50 bg-white "
                            :w="25"
                            :h="25"
                            @click.native="closeModal"/>
                <button class="absolute right-8 top-2 z-50  px-3 py-1 bg-primary text-white mx-2 rounded-md"
                        :w="25"
                        :h="25"
                        @click="closeModal">
                    Apply
                </button>
            </template>
            <modal-map
                :type="geography"
                :markerProp="marker"
                :zoom="zoom"
                :radius="radius"
                :markerType="markerType"
                ref="modalMap"
                @set-polygon="setPolygon"
            />
        </modal>
        <!--        <modalMap></modalMap>-->
    </div>
</template>

<script>
import { EventBus } from "@widget/plugins/event-bus";
import modalMap from "@widget/components/modals/modal-map";
export default {
    name: "geography",
    props: {
        withStep: {
            type: Boolean,
            default: true
        },
    },
    components: {
        searchState: () => import("@widget/components/geography/search-state"),
        searchZip: () => import("@widget/components/geography/search-zip"),
        searchMap: () => import("@widget/components/geography/search-map"),
        googleMap: () => import("@widget/components/geography/google-map"),
        modalMap
    },
    computed: {
        listing () {
            let geos = this.$store.getters["widgetData/getAudienceSelections"]("GEO");
            let sortedArray = [];
            ["geo_search", "multi-location-radius", "mapping"].forEach(item => {
                let findItem = geos.find(_item => _item.type === item);
                if (findItem) {
                    sortedArray.push(findItem);
                }
            });
            return sortedArray;
        },
        geography: {
            set (value) {
                this.$store.commit("widgetData/setGeography", value);
            },
            get () {
                return this.$store.getters["widgetData/getGeography"];
            }
        },
        audience () {
            return this.$store.getters["widgetData/selectedData"].audience;
        },
        codeGeo () {
            return this.audience === this.$widgetConfig.b2cBase ? "b2c_geo_search" : "b2b_geo_search";
        },
        activeItemList () {
            return this.listing.find(item => item.type === this.geography);
        }
    },
    watch: {
        audience () {
            this.$store.commit("widgetData/setGeography");
        }
    },
    methods: {
        closeModal () {
            this.$modal.hide("modal-map");
            this.marker= {};
            this.zoom= 4;
            this.radius= 0;
            this.markerType= null;
        },
        showMapModal()
        {
            this.$modal.show("modal-map");
            console.log("show modal",this.marker)
            if(this.marker.lat!=null && this.marker.lng!=null) {
                let makerObject = {
                    type: this.markerType,
                    latitude: this.marker.lat,
                    longitude: this.marker.lng,
                    radius: this.radius
                }
                setTimeout(() => {
                    this.$refs.modalMap.resetMap();
                    if(this.geography=='geo_search' && this.marker.lat!=null) {
                        this.selectedState(makerObject);
                    }if(this.geography=='multi-location-radius' && this.radius>0) {
                        this.selectedZip(makerObject);
                    }if(this.geography=='mapping' && this.markerType!=null) {
                        this.selectedMap(makerObject);
                    }
                }, 500);
            }
        },
        selectedState (object) {
            this.marker = {
                lat: parseFloat(object.latitude),
                lng: parseFloat(object.longitude)
            };
            this.markerType = object.type;
        },
        selectedZip (object) {
            this.marker = {
                lat: parseFloat(object.latitude),
                lng: parseFloat(object.longitude)
            };
            this.radius = parseInt(object.radius);
            this.markerType = object.type;
        },
        selectedMap (object) {
            this.marker = {
                lat: parseFloat(object.latitude),
                lng: parseFloat(object.longitude)
            };
            this.markerType = object.type;
        },
        changeRadius (event) {
            if (!this.marker.lat && !this.marker.lng) {
                return false;
            }
            let radius = parseInt(event);
            if (radius <= 5) {
                this.zoom = 12;
            } else if (radius > 5 && radius <= 10) {
                this.zoom = 10;
            } else if (radius > 10 && radius <= 25) {
                this.zoom = 10;
            } else if (radius > 25 && radius <= 50) {
                this.zoom = 8;
            } else if (radius > 50 && radius <= 250) {
                this.zoom = 6;
            } else if (radius > 250) {
                this.zoom = 4;
            }
            this.radius = radius;
        },
        setPolygon (object) {
            let coordinates = [],
                path = object.coordinates.getArray(),
                path0 = path[0];
            path.forEach((item) => {
                coordinates.push(item.lat() + " " + item.lng());
            });
            coordinates.push(path0.lat() + " " + path0.lng());

            this.$store.commit("widgetData/addSelectGeo", {
                sensitive: false,
                code: this.activeItemList.code,
                title: `Polygon ( ${object.area} )`,
                query: coordinates.join(",")
            });
        }
    },
    data () {
        return {
            marker: {},
            zoom: 4,
            radius: 0,
            markerType: null
        };
    },
    mounted () {
        EventBus.$on("show-select-position", (select) => {
            let geographyTip = false;
            let value = "all";

            if (select.code) {
                if (select.code.includes("_geo_search")) {
                    value = "geo_search";
                    geographyTip = true;
                } else if (select.code.includes("_zip_radius")) {
                    value = "multi-location-radius";
                    geographyTip = true;
                } else if (select.code.includes("_mapping")) {
                    value = "mapping";
                    geographyTip = true;
                }
            } else if (select === "geography") {
                geographyTip = true;
            }

            if (geographyTip) {
                EventBus.$emit("show-tippy-modify", this.$refs["geography"]);
            }

            this.$store.commit("widgetData/setGeography", value);
        });
    }
};
</script>
<style>
.bg-text {
    background-color: rgb(0,0,0); /* Fallback color */
    background-color: rgba(0,0,0, 0.4); /* Black w/opacity/see-through */
    color: white;
    font-weight: bold;
    border: 3px solid #f1f1f1;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;
    width: 80%;
    padding: 20px;
    text-align: center;
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    justify-items: center;
    align-items: center;
    border-radius: 1rem;
}
.vue-map-container .vue-map{
    border-radius: 1rem;
}

</style>
